import { render, staticRenderFns } from "./ProjectActivityList.vue?vue&type=template&id=18ee5068&"
import script from "./ProjectActivityList.vue?vue&type=script&lang=js&"
export * from "./ProjectActivityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports